import { useTranslation } from 'react-i18next';
import styles from './PriceDeviationTable.module.css';
import classNames from 'classnames';
import { getRenderablePriceDeviationsData } from '@/services/menu/menus.helper.service';
import { PriceDeviation, PriceDeviationResponse } from '@/types/menus.types';

export const PriceDeviationsTable = ({ data }: { data: PriceDeviationResponse[] }) => {
  const { t } = useTranslation();
  const majorityExists = data.find((pdr: PriceDeviationResponse) => pdr.majorityPricePoint !== null);

  const { sortedStores, renderableData } = getRenderablePriceDeviationsData(data);

  return (
    <table className={styles.table}>
      <tr>
        <th rowSpan={2} className={styles.productsHeader}>
          {t('priceDeviations.table.products')}
        </th>
        {majorityExists && (
          <th rowSpan={2} className={styles.majorityHeader}>
            {t('priceDeviations.table.majorityPricePoint')}
          </th>
        )}
        <th colSpan={sortedStores.length} className={styles.deviationsHeader}>
          {t('priceDeviations.table.priceDeviationsByStore')}
        </th>
      </tr>
      <tr>
        {sortedStores.map((store: string) => (
          <td className={styles.storeHeader} key={store}>
            {store}
          </td>
        ))}
      </tr>
      {renderableData.map((product: PriceDeviationResponse, index: number) => (
        <tr
          className={classNames({ [styles.evenRow]: index % 2 === 0 })}
          key={product.productName + product.productDescription}
        >
          <td>
            <div>
              <div className={styles.productName}>{product.productName}</div>{' '}
              <div className={styles.productDescription}>{product.productDescription}</div>
            </div>
          </td>
          {majorityExists && (
            <td
              className={classNames(styles.majorityPrice, {
                [styles.majorityEven]: index % 2 === 0,
                [styles.majorityOdd]: index % 2 !== 0,
              })}
            >
              {product.majorityPricePoint ? `$${product.majorityPricePoint}` : '--'}
            </td>
          )}
          {product.priceDeviations.map((deviation: PriceDeviation, count: number) => (
            <td className={classNames(styles.price, { [styles.firstPrice]: count === 0 })} key={deviation.storeNumber}>
              {deviation.price ? `$${deviation.price}` : ''}
            </td>
          ))}
        </tr>
      ))}
    </table>
  );
};
